(() => {
  const states = new WeakMap();
  const images = new Map();
  const animations = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const prepareImage = (src) => {
    if (!images.has(src)) {
      const image = new Image();
      image.src = src;
      const ready = typeof image.decode === 'function'
        ? image.decode()
        : new Promise((resolve, reject) => {
          if (image.complete) image.naturalWidth ? resolve() : reject();
          else { image.onload = resolve; image.onerror = reject; }
        });
      images.set(src, ready.then(() => image).catch(() => null));
    }
    return images.get(src);
  };
  const stateFor = (card) => {
    if (!states.has(card)) {
      const price = card.querySelector('.product-card__price');
      states.set(card, {
        selected: null,
        version: 0,
        price,
        defaultPrice: price?.textContent,
        links: [...card.querySelectorAll('.product-card__title, .reference-product__details h3 a, .product-card__price, .product-card__viewport, .reference-product__link, a[data-quick-add-control]')].map((link) => [link, link.getAttribute('href')]),
        layers: new Map()
      });
    }
    return states.get(card);
  };
  const setMaterial = (card, value) => {
    const material = card.querySelector('[data-card-material]');
    if (!material) return;
    const labels = value.split('|').filter(Boolean);
    if ([...material.children].map((span) => span.textContent).join('|') === labels.join('|')) return;
    material.replaceChildren(...labels.map((label) => {
      const span = document.createElement('span');
      span.textContent = label;
      return span;
    }));
  };
  const fade = (image, to) => {
    const from = Number(getComputedStyle(image).opacity);
    animations.get(image)?.cancel();
    image.style.opacity = String(to);
    if (reducedMotion.matches || from === to) return;
    const animation = image.animate([{ opacity: from }, { opacity: to }], {
      duration: 320,
      easing: 'cubic-bezier(.25,.1,.25,1)'
    });
    animations.set(image, animation);
  };
  const select = async (button) => {
    const card = button.closest('.product-card');
    const viewport = card?.querySelector('.product-card__viewport, .reference-product__media');
    if (!card || !viewport) return;
    const state = stateFor(card);
    const selected = state.selected === button ? null : button;
    state.selected = selected;
    const version = ++state.version;
    card.classList.remove('is-mobile-preview');
    const choices = [...card.querySelectorAll('[data-card-color]')];
    if (selected) selected.parentElement.style.setProperty('--card-swatch-index', String(choices.indexOf(selected)));
    choices.forEach((choice) => choice.setAttribute('aria-pressed', String(choice === selected)));
    if (state.price) state.price.textContent = selected ? selected.dataset.cardPrice : state.defaultPrice;
    state.links.forEach(([link, original]) => link.setAttribute('href', selected ? selected.dataset.cardVariantUrl : original));
    const material = card.querySelector('[data-card-material]');
    if (material) setMaterial(card, selected ? selected.dataset.cardVariantMaterial : material.dataset.defaultMaterial);
    if (!selected) {
      state.layers.forEach((layer) => fade(layer, 0));
      return;
    }
    const ready = await prepareImage(selected.dataset.cardImage);
    if (!ready || version !== state.version || !card.isConnected) return;
    let layer = state.layers.get(ready.src);
    if (!layer) {
      layer = document.createElement('img');
      layer.className = 'product-card__choice-image';
      layer.alt = selected.dataset.cardImageAlt;
      layer.width = ready.naturalWidth;
      layer.height = ready.naturalHeight;
      layer.draggable = false;
      layer.src = ready.src;
      viewport.append(layer);
      state.layers.set(ready.src, layer);
    }
    state.layers.forEach((image) => fade(image, image === layer ? 1 : 0));
  };
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-card-color]') : null;
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    select(button);
  });
  const warm = (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-card-color]') : null;
    if (button) button.parentElement.querySelectorAll('[data-card-color]').forEach((choice) => prepareImage(choice.dataset.cardImage));
  };
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('pointerdown', warm, { passive: true });
  document.addEventListener('focusin', warm);
})();
